import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { SkapaTokens } from '@inter-ikea-guida/skapa';
const StyledButtonContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${SkapaTokens.space100};
  z-index: 1;

  padding: ${SkapaTokens.space150} 0;
  bottom: 0;
  position: sticky;

  background-color: white;
`;
export const GuideFooter = ({ children }) => {
    return _jsx(StyledButtonContainer, { children: children });
};
//# sourceMappingURL=GuideFooter.js.map